import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";



interface Parameter {
    currentProductId: string;
    carouselId: string;
}

interface Props {
    products?: ProductModel[];
    productInfos?: ProductInfo[];
}
type HandlerType = Handler<Parameter, Props>;

export const RelatedProductsCarouselIdMapping: HandlerType = props => {
   
    (props as unknown as any).dispatch({
        type:"Components/RelatedProductFilter/CompleteRelatedProductFilterIds",
        relatedProductsCarouselIdMapping:{currentProductId: props.parameter.currentProductId, carouselId: props.parameter.carouselId}
    })
};

export const chain = [RelatedProductsCarouselIdMapping]

const relatedProductsCarouselIdMapping = createHandlerChainRunner(chain, "RelatedProductsCarouselIdMapping");
export default relatedProductsCarouselIdMapping;


